import { render } from "./BuyPage.vue?vue&type=template&id=466c6234&scoped=true"
import script from "./BuyPage.vue?vue&type=script&lang=js"
export * from "./BuyPage.vue?vue&type=script&lang=js"

import "./BuyPage.vue?vue&type=style&index=0&id=466c6234&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466c6234"]])

export default __exports__